import axios from "axios";

const url = process.env.REACT_APP__BASE_URL;

const token = process.env.REACT_APP_SMS_KEY;

const patstackUrl = process.env.REACT_APP_PAYSTACK_URL;

const senderID = process.env.REACT_APP_SMS_ID;

const smsUrl = process.env.REACT_APP_SMS_URL;

const Mail_UserID = `Z5ZG0Ua9CXbWizkTO`;

const Service_ID = `service_04mgbhw`;

const template_id = `template_fb93vwr`;

const FixedAgent = {
  getProductList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/product/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getManualProductList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/product/list`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getManualCartList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/checkout`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  addToCart: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/add-to-cart`,
      method: "POST",
      data: JSON.stringify({
        plate_no: payload.plate_no,
        product_id: payload.product_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  removeFromCart: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/remove-from-cart`,
      method: "POST",
      data: JSON.stringify({
        plate_no: payload.plate_no,
        product_id: payload.product_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  sendSms: (payload) => {
    const response = axios({
      url: `${smsUrl}/sms?token=${token}&senderID=${senderID}&recipients=${payload.recipients}&message=${payload.message}&gateway=2`,
      method: "POST",
      data: JSON.stringify({
        token,
        senderID,
        recipients: payload.recipients,
        message: payload.message,
        gateway: 2,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  getAllCustomers: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/my/customers`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerByPlateNumber: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getSubscription: (payload) => {
    const response = axios({
      url: `${patstackUrl}/subscription`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getManualOrderDetails: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/fetch-manual-order-details/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCreditHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/wallet/credit?page=${payload.page_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getDebitHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/wallet/debit?page=${payload.page_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getManualDebitHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/fetch-manual-order-transactions`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getOrderHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/orders`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getOrderDetails: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/fetch-manual-order-details/${payload.order_id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  sendWhatsAppMessageToNonUser: (payload) => {
    const response = axios({
      url: `${url}/app/whatsapp/send-to-non-user`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
      data: {
        phone_no: payload.phone_no,
        message: payload.message,
      },
    });
    return response;
  },

  createCeiUpdate: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/policy-correction/cei/create`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
      data: {
        order_item_id: payload.order_item_id,
      },
    });
    return response;
  },

  ceiUpdate: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/policy-correction/cei/update`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        correction_id: payload.correction_id,
      },
    });
    return response;
  },

  sendWhatsAppMessageForCeiEdit: (payload) => {
    const response = axios({
      url: `${url}/app/whatsapp/button/cei`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
      data: {
        phone_no: payload.phone_no,
        url: payload.url,
        correction_id: payload.correction_id,
      },
    });
    return response;
  },

  getManualOrderHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/fetch-manual-orders`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getRoadData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/road/online/data/${payload.plate_no}
`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerOnlineData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/online/data/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerInsuranceOnlineData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/ishola-badmus/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getCustomerInsuranceSecondOnlineData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/akorede`,
      method: "POST",
      data: JSON.stringify({
        plate: payload.plate_no,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getInsuranceData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/uncle-rex?regnum=${payload.plate_no}
`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNiconInsuranceData: (payload) => {
    // Define endpoints with source identifiers
    const endpoints = [
      // {
      //   url: `${url}/app/fixedagent/customer/shobo/${payload.plate_no}`,
      //   source: "SHOBO",
      // },
      {
        url: `https://api.etapinsure.com/web-apis/vehicles-policy/lookup?plateNumber=${payload.plate_no}`,
        source: "ETAP",
      },
      // Commented out endpoints - uncomment and add source when needed:
      //  {
      //    url: `${url}/app/fixedagent/get-nicon-policy?policy_number=${payload.plate_no}`,
      //    source: 'NICON_POLICY',
      //  },
      //  {
      //    url: `${url}/app/fixedagent/customer/ishola-badmus/${payload.plate_no}`,
      //    source: 'ISHOLA_BADMUS',
      //  },
      //  {
      //    url: `${url}/app/fixedagent/customer/akorede/${payload.plate_no}`,
      //    source: 'AKOREDE',
      //  },
    ];

    const cancelTokens = endpoints.map(() => axios.CancelToken.source());

    const requests = endpoints.map(({ url, source }, index) =>
      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${payload.token}`,
        },
        cancelToken: cancelTokens[index].token,
      }).then((response) => {
        // Cancel other requests on success
        cancelTokens.forEach((token, i) => {
          if (i !== index)
            token.cancel("Request cancelled - faster endpoint responded");
        });

        // Add data source to response for tracking
        return {
          ...response,
          dataSource: source,
        };
      }),
    );

    return Promise.any(requests);
  },

  getVlData: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/vl/online/data/${payload.plate_no}
`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getColors: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/rainbow/${payload.plate_no}
`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  downloadPolicy: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/order/ieiplc/download/${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  addNewCustomer: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/register`,
      method: "POST",
      data: JSON.stringify({
        fullname: payload.fullname,
        email: payload.email,
        phone_no: payload.phone_no,
        date_of_birth: payload.date_of_birth,
        gender: payload.gender,
        occupation: payload.occupation,
        address: payload.address,
        plate_no: payload.plate_no,
        chassis: payload.chassis,
        engine_number: payload.engine_number,
        make: payload.make,
        model: payload.model,
        color: payload.color,
        state: payload.state,
        year: payload.year,
        issue_date: payload.issue_date,
        expiry_date: payload.expiry_date,
        vl_issue_date: payload.vl_issue_date,
        vl_expiry_date: payload.vl_expiry_date,
        road_expiry_date: payload.road_expiry_date,
        road_message: payload.road_message,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  makeOrder: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/customer/order/ieiplc/makeanorder`,
      method: "POST",
      data: JSON.stringify({
        product_id: payload.product_id,
        FullName: payload.FullName,
        EmailAddress: payload.EmailAddress,
        State: payload.State,
        MobileNumber: payload.MobileNumber,
        DateOFBirth: payload.DateOFBirth,
        Gender: payload.Gender,
        Occupation: payload.Occupation,
        Adddress: payload.Adddress,
        RegistrationNumber: payload.RegistrationNumber,
        ChassisNumber: payload.ChassisNumber,
        EngineNumber: payload.EngineNumber,
        VehicleMake: payload.VehicleMake,
        VehicleModel: payload.VehicleModel,
        YearOfMake: payload.YearOfMake,
        VehicleColour: payload.VehicleColour,
        type: payload.type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  makeManualOrder: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/maker-manual-order`,
      method: "POST",
      data: JSON.stringify({
        plate_no: payload.plate_no,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  makeManualInsuranceOrder: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/make-insurance-manual-order`,
      method: "POST",
      data: JSON.stringify({
        plate_no: payload.plate_no,
        payment_option: payload.payment_option,
        pin_type: payload.pin_type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  sendTicket: (payload) => {
    const response = axios({
      url: `https://api.emailjs.com/api/v1.0/email/send`,
      method: "POST",
      data: JSON.stringify({
        service_id: Service_ID,
        template_id: template_id,
        user_id: Mail_UserID,
        template_params: {
          to_name: payload.to_name,
          from_name: payload.from_name,
          message: payload.message,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  },

  getPinList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNewPinList: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/list?status=${payload.status}&platform=${payload.platform}&type=${payload.type}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  sellPin: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/sell`,
      method: "POST",
      data: JSON.stringify({
        count: payload.count,
        fixedagent_email: payload.fixedagent_email,
        export_option: payload.export_option,
        pin_type: payload.pin_type,
        type: payload.type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  exportPins: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/export/${payload.count}/${payload.pinType}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newExportPins: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/export/${payload.count}/${payload.pinType}/${payload.type}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  boughtListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/bought-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newBoughtListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/new-bought-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },
  soldListHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/sold-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },
  exportedPinsHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/list?status=EXPORTED`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  newExportedPinsHistory: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/exported-pin-list`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  exportedPin: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/exported-pins?ids=${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNewExportedPin: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/pin/get-sales-exported-details-by-id/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  makeCEIManualInsuranceOrder: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/instant/make-insurance-instant-manual-order`,
      method: "POST",
      data: JSON.stringify({
        product_id: payload.product_id,
        plate_no: payload.plate_no,
        payment_option: payload.payment_option,
        fullname: payload.fullname,
        email: payload.email,
        chassis: payload.chassis,
        engine_number: payload.engine_number,
        cei_make_id: payload.cei_make_id,
        cei_model_id: payload.cei_model_id,
        year: payload.year,
        cei_color_id: payload.cei_color_id,
        commercial_type: payload.commercial_type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getVehicleColours: (payload) => {
    const response = axios({
      url: `https://api.ceiil.com.ng/Common/GetVehicleColors`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getVehicleModelsByID: (payload) => {
    const response = axios({
      url: `https://api.ceiil.com.ng/Common/GetVehicleModels/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getPlainPolicyDocument: (payload) => {
    const response = axios({
      url: `https://certs.ceiil.com.ng/Certificate/GetPlainPolicyDocumentByRegistrationNumber/${payload.plateNo}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  getNiconVehicleModels: (payload) => {
    const response = axios({
      url: `${url}/app/admin/manual/headless/fetch-nicon-models/${payload.id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  makeNiconManualInsuranceOrder: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/manual/instant/make-nicon-insurance-instant-manual-order`,
      method: "POST",
      data: JSON.stringify({
        product_id: payload.product_id,
        plate_no: payload.plate_no,
        payment_option: payload.payment_option,
        EffectiveDate: payload.EffectiveDate,
        fullname: payload.fullname,
        email: payload.email,
        chassis: payload.chassis,
        engine_number: payload.engine_number,
        nicon_make_id: payload.nicon_make_id,
        nicon_model_id: payload.nicon_model_id,
        year: payload.year,
        color: payload.color,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  checkDaraKStatus: (payload) => {
    const response = axios({
      url: `${url}/app/fixedagent/policy-information?policyOrPlateNumber=${payload.plate_no}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    return response;
  },

  fetchMakeModelSpreadsheet: (payload) => {
    const response = axios({
      url: payload.sheetUrl,
      method: "GET",
      headers: {
        "Content-Type": "text/csv",
      },
    });
    return response;
  },
};

export default FixedAgent;
